// Central brand configuration for EFORY
export const BRAND = {
  name: "EFORY",
  tagline: "Soluções financeiras e comerciais para o seu negócio crescer",
  logo: "/efory-logo.png",
  mark: "/efory-mark.png",
  whatsappNumber: "5531996963714",
  whatsappDisplay: "+55 31 99696-3714",
  instagram:
    "https://www.instagram.com/eforyoficial?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
  instagramHandle: "@eforyoficial",
  linkedin: "https://www.linkedin.com/company/efory/",
  founder: "Bernardo Henriques",
  founderInstagram: "https://www.instagram.com/bernardohenriqs",
};

export const IMAGES = {
  hero:
    "https://static.prod-images.emergentagent.com/jobs/9e70c3a0-45b9-4ff4-866e-a06ff971a4d7/images/07df7ee6062b3ca0305c0ac5d9a49267b0e4e22ff4e0b0f218cc1d30c894acce.png",
  numbers:
    "https://static.prod-images.emergentagent.com/jobs/9e70c3a0-45b9-4ff4-866e-a06ff971a4d7/images/b257300383117ca1e725e65e9eebeba6cc6a3bc925a5dc1785423962926f9fac.png",
  author:
    "https://customer-assets.emergentagent.com/job_plataforma-consultor/artifacts/kq8p5lwk_WhatsApp%20Image%202026-07-03%20at%2012.04.16.jpeg",
};

export const buildWhatsappLink = (message) => {
  const text = encodeURIComponent(message || "Olá! Vim pelo site da EFORY e gostaria de saber mais.");
  return `https://wa.me/${BRAND.whatsappNumber}?text=${text}`;
};
